import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

interface SitePolicy {
  key: string;
  title: string;
  body: string;
}

@Component({
  selector: 'app-footer-legal-policies',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer-legal-policies.html',
  styleUrl: './footer-legal-policies.scss',
})
export class FooterLegalPolicies implements OnInit {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);

  readonly shippingBody = signal<string | null>(null);
  readonly returnsBody = signal<string | null>(null);

  ngOnInit(): void {
    // Skip during SSR/prerender — relative `/policies` has no backend there.
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.http.get<{ data?: SitePolicy[] }>(`${environment.apiBaseUrl}/policies`).subscribe({
      next: (res) => {
        const policies = res.data ?? [];
        const shipping = policies.find((p) => p.key === 'shipping');
        const returns = policies.find((p) => p.key === 'returns');
        if (shipping?.body) {
          this.shippingBody.set(shipping.body);
        }
        if (returns?.body) {
          this.returnsBody.set(returns.body);
        }
      },
      error: () => {
        // Keep static HTML fallbacks when the API is unavailable.
      },
    });
  }

  paragraphs(body: string): string[] {
    return body
      .split(/\n\s*\n/)
      .map((part) => part.trim())
      .filter(Boolean);
  }
}
